<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.214 7.57358C14.32 7.7377 14.4078 7.88214 14.4767 8.00002C14.4078 8.11789 14.32 8.26234 14.214 8.42646C13.9086 8.89934 13.4565 9.52797 12.8698 10.1537C11.6829 11.4198 10.034 12.5834 8.00033 12.5834C5.96662 12.5834 4.3178 11.4198 3.13081 10.1537C2.54416 9.52797 2.09201 8.89934 1.78661 8.42646C1.68061 8.26234 1.59288 8.1179 1.5239 8.00002C1.59288 7.88214 1.68061 7.7377 1.78661 7.57358C2.09201 7.1007 2.54416 6.47207 3.13081 5.84631C4.3178 4.58019 5.96662 3.41669 8.00033 3.41669C10.034 3.41669 11.6829 4.58019 12.8698 5.84631C13.4565 6.47207 13.9086 7.1007 14.214 7.57358Z"
      stroke="#5C5C5C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.25 8C9.25 8.69036 8.69036 9.25 8 9.25C7.30964 9.25 6.75 8.69036 6.75 8C6.75 7.30964 7.30964 6.75 8 6.75C8.69036 6.75 9.25 7.30964 9.25 8Z"
      stroke="#5C5C5C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon',
}
</script>

<style scoped>
svg {
  cursor: pointer;
}
</style>
